<template lang="html">

  <section class="ficha -practica">

    <template v-if="!!data">
      <h2 class="ficha-title" :style="styles.colorBasic">Información del puesto</h2>
     
      <article class="group">
          <div class="contenedor-data" v-if="!!data.puesto">
            <h4 class="data-title" :style="styles.colorBasic">Nombre Oferta</h4>
            <p>{{data.puesto}}</p>
          </div>
          <div class="contenedor-data" v-if="!!data.numeroPlazas">
            <h4 class="data-title" :style="styles.colorBasic">Número de plazas</h4>
            <p>{{data.numeroPlazas}}</p>
          </div>
          <div class="contenedor-data" v-if="!!data.areaFuncional">
            <h4 class="data-title" :style="styles.colorBasic">Área funcional</h4>
            <p>{{data.areaFuncional}}</p>
          </div>
          <div class="contenedor-data -full" v-if="!!data.descripcionPuesto">
            <h4 class="data-title" :style="styles.colorBasic">Descripción del puesto</h4>
            <div v-html="data.descripcionPuesto"></div>
          </div>
          <div class="contenedor-data" v-if="!!data.empresa.direccion">
            <h4 class="data-title" :style="styles.colorBasic">Dirección</h4>
            <p>{{data.empresa.direccion}}</p>
          </div>
          
          <div class="contenedor-data" v-if="!!data.empresa.localidad">
            <h4 class="data-title" :style="styles.colorBasic">Localidad</h4>
            <p>{{data.empresa.localidad}}</p>
          </div>
          
          <div class="contenedor-data" v-if="!!data.empresa.provincia">
            <h4 class="data-title" :style="styles.colorBasic">Provincia</h4>
            <p>{{data.empresa.provincia}}</p>
          </div>
          
          <div class="contenedor-data" v-if="!!data.empresa.paisDescripcion">
            <h4 class="data-title" :style="styles.colorBasic">País</h4>
            <p>{{data.empresa.paisDescripcion}}</p>
          </div>
        <div class="contenedor-data w-100" v-if="!!data.ayudaAlEstudio">
          <h4 class="data-title" :style="styles.colorBasic">Remuneración</h4>
          <p>{{data.ayudaAlEstudio}} €</p>
        </div>
        <div class="contenedor-data" v-if="!!data.horario">
            <h4 class="data-title" :style="styles.colorBasic">Días a la semana</h4>
            <p>{{data.horario}}</p>
        </div>
        <div class="contenedor-data" v-if="data.horasAlDia != ''">
            <h4 class="data-title" :style="styles.colorBasic">Horas al día</h4>
            <p>{{data.horasAlDia}}</p>
        </div>
        <div class="contenedor-data" v-if="!!data.fechaInicio">
            <h4 class="data-title" :style="styles.colorBasic">Fecha de inicio</h4>
            <p>{{data.fechaInicio}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.fechaFin">
            <h4 class="data-title" :style="styles.colorBasic">Fecha de fin</h4>
            <p>{{data.fechaFin}}</p>
        </div>
     

      
      </article>
    </template>

  </section>

</template>

<script lang="js">
  import {
    mapGetters,
    mapActions
  } from 'vuex';

  import onlyArrow from '@/components/parts/icons/only-arrow';
  import arrowlink from '@/components/parts/icons/arrow-link';

  import addDocumentacion from '@/components/parts/add-documentacion';

  export default {
    name: 'ficha-practica',
    props: ['data'],
    data() {
      return {
        showadddocumentacion: false,
        uploadtype: '',
        documentacionPendiente: []
      }
    },
    mounted() {
      
    },
    methods: {
      

    },
    computed: {
      ...mapGetters({
        styles: 'getStyles',
        documentos: 'getDocumentos',
        uploaddoc: 'getCanUploadDocPracticas',
        brand: 'getBrand'
      }),

    },
    components: {
      'only-arrow': onlyArrow,
      'arrow-link': arrowlink,
      'add-documentacion': addDocumentacion
    }

  }
</script>

<style scoped lang="scss">
 .contact-section{
  display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #dedede;
    margin-bottom: 15px;
    padding-bottom: 15px;
 }

</style>


// WEBPACK FOOTER //
// src/components/views/ficha-info-puesto.vue